export default "__VITE_ASSET__PExc2Aaj__"